import { useLocale } from "../../../hooks";
import { Menu } from "../menu";

import "./index.scss";

export const GuidesMenu = ({ visibleSubMenuId, toggleMenu }) => {
  const locale = useLocale();

  const menu = {
    id: "guides",
    label: "开发指南",
    to: `/${locale}/docs/Learn`,
    items: [
      {
        description: "学习 Web 开发",
        hasIcon: true,
        extraClasses: "apis-link-container mobile-only",
        iconClasses: "submenu-icon learn",
        label: "概述 / MDN 学习区",
        url: `/${locale}/docs/Learn`,
      },
      {
        description: "学习 Web 开发",
        extraClasses: "apis-link-container desktop-only",
        hasIcon: true,
        iconClasses: "submenu-icon learn",
        label: "MDN 学习区",
        url: `/${locale}/docs/Learn`,
      },
      {
        description: "学习使用 HTML 构建 Web 内容",
        extraClasses: "html-link-container",
        hasIcon: true,
        iconClasses: "submenu-icon html",
        label: "HTML",
        url: `/${locale}/docs/Learn/HTML`,
      },
      {
        description: "学习使用 CSS 设置内容样式",
        extraClasses: "css-link-container",
        hasIcon: true,
        iconClasses: "submenu-icon css",
        label: "CSS",
        url: `/${locale}/docs/Learn/CSS`,
      },
      {
        description: "学习在浏览器中运行脚本",
        extraClasses: "javascript-link-container",
        hasIcon: true,
        iconClasses: "submenu-icon javascript",
        label: "JavaScript",
        url: `/${locale}/docs/Learn/JavaScript`,
      },
      
    ],
  };
  const isOpen = visibleSubMenuId === menu.id;

  return <Menu menu={menu} isOpen={isOpen} toggle={toggleMenu} />;
};
